import { render, staticRenderFns } from "./CriarLote.vue?vue&type=template&id=5988fec5&"
import script from "./CriarLote.vue?vue&type=script&lang=js&"
export * from "./CriarLote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports